import React, { useContext } from 'react'

const ModalSelector = ({icons}) => {
  return <></>
}

export default ModalSelector
